import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./DateRangeFilter.module.scss";
import { enGB } from "date-fns/locale";
import { ReactComponent as CalendarIcon } from "../../icons/calendar.svg";

// Register the locale that starts weeks on Monday
registerLocale("en-GB", enGB);

const DateRangeFilter = ({
  dateRange,
  handleDateRangeChange,
  isClearable,
  className = "",
}) => {
  const [startDate, endDate] = dateRange;

  const CustomButton = React.forwardRef(({ value, onClick }, ref) => (
    <button
      type="button"
      className={`${styles.customInput} ${!startDate && !endDate ? styles.placeholder : ""} ${className}`}
      onClick={onClick}
      ref={ref}
    >
      {value ? value : "Start date - End date"}
      <CalendarIcon
        className={`${styles.calendarIcon} ${!startDate && !endDate ? styles.grayIcon : ""}`}
      />
    </button>
  ));

  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => handleDateRangeChange(update)}
      dateFormat="dd/MM/yyyy"
      wrapperClassName="dateRangePicker"
      isClearable={isClearable}
      customInput={<CustomButton />}
      popperPlacement="bottom-start"
      popperProps={{
        strategy: "absolute",
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: [],
            },
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "clippingParents",
              padding: 0,
            },
          },
          {
            name: "offset",
            options: {
              offset: [0, 10],
            },
          },
        ],
      }}
    />
  );
};

export default DateRangeFilter;
